import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './Typography.scss';

const typographyPropTypes = {
	size: PropTypes.oneOf([
		'xsmall',
		'tiny',
		'small',
		'smallMedium',
		'standardMedium',
		'medium',
		'mediumLarge',
		'large',
		'xlarge', // sf_14850_hero_promo_test variation 2
		'megaMobile',
		'mega',
	]),
	color: PropTypes.oneOf([
		'black',
		'red',
		'white',
		'green',
		'greenHero',
		'promoGreen', // sf_14850_hero_promo_test variation 1 + 2
		'blue',
		'priceBlue',
		'lightGray',
		'gray',
		'darkGray',
		'secondaryBlue',
		'placeholderGray',
		'orange',
		'priceBlue',
	]),
	weight: PropTypes.oneOf([
		'extraLight',
		'light',
		'standard',
		'medium',
		'bold',
		'extraBold',
	]),
	eyebrow: PropTypes.bool,
};

export const withTypography = (element) => {
	const TypographyComponent = (props) => {
		let { color, size, ...rest } = props;

		if (props.eyebrow) {
			color = color || 'gray';
			size = 'tiny';
		}

		const {
			children,
			className,
			eyebrow,
			weight,
			last,
			strikethrough,
			itemProp,
			itemScope,
			itemType,
			centered,
		} = { ...rest, color, size };

		const Element = element;

		return (
			<Element
				itemProp={itemProp}
				itemScope={itemScope}
				itemType={itemType}
				className={classnames(
					className,
					'ss-type',
					!!strikethrough && 'ss-type-strike',
					!!last && 'ss-type-last',
					!!size && `ss-type-${size}`,
					!!color && `ss-type-${color}`,
					!!weight && `ss-type-weight-${weight}`,
					!!eyebrow && 'ss-type-eyebrow',
					!!centered && 'ss-type-text-align-center',
				)}
			>
				{children}
			</Element>
		);
	};
	TypographyComponent.displayName = element.toUpperCase();
	TypographyComponent.propTypes = typographyPropTypes;
	return TypographyComponent;
};

export const H1 = withTypography('h1');
export const H2 = withTypography('h2');
export const H3 = withTypography('h3');
export const H4 = withTypography('h4');
export const H5 = withTypography('h5');
export const H6 = withTypography('h6');
export const Paragraph = withTypography('p');
export const Text = withTypography('span');
export const OrderedList = withTypography('ol');
export const UnorderedList = withTypography('ul');
export const ListItem = withTypography('li');
